(function (angular) {
	angular.module('bizPartEngage').directive('bizSearch', bizSearchDirective);
	angular.module('bizPartEngage').service('bizSearchService', bizSearchService);

	bizSearchDirective.$inject = ["bizCore"];
	bizSearchService.$inject = ["$state"];

    function bizSearchDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
            	ReferrerType: "@referrerType",
				ReferrerId: "@referrerId",
				Expand: "=?expand"
            },
            templateUrl: bizCoreProvider.getView('core.directives.search', "FrontEnd/Core/Directives/Views/Search.html"),
            controller: bizSearchController,
            controllerAs: "vm",
            bindToController: true
        }

        bizSearchController.$inject = ["core.users.service", "bizCoreService", "bizSearchService", "$state"];

        function bizSearchController(userService, bizCoreService, bizSearchService, $state) {
        	var vm = this;
			vm.MaxHits = 20;
			vm.CanSearch = true;

        	vm.Search = Search;        	
        	vm.GoToResult = GoToResult;
        	vm.GoToResults = GoToResults;

        	vm.HitsIncement = 4;

        	function GoToResults() {
        		vm.Expand = false;

        		if (!vm.SearchText)
        			return;

        		$state.go('base.modules.search', { query: vm.SearchText});
        	}

        	function Search() {
        		if (!vm.SearchText || vm.SearchText.length < 3 || !vm.CanSearch)
        		    return;

        		if (!vm.SearchIndexList) {
        		    vm.SearchIndexList = [
                    { Index: 2, SearchIndexExternalName: "Page", TotalHits: vm.HitsIncement },
                    { Index: 3, SearchIndexExternalName: "Blog", TotalHits: vm.HitsIncement },
                    { Index: 4, SearchIndexExternalName: "Dictionary", TotalHits: vm.HitsIncement },
                    { Index: 5, SearchIndexExternalName: "Video", TotalHits: vm.HitsIncement },
        		    { Index: 6, SearchIndexExternalName: "Educations", TotalHits: vm.HitsIncement }];
				}
				
				vm.CanSearch = false;
				console.log('CAN SEARCH: ', vm.CanSearch);
				setTimeout(function(vm) {
					vm.CanSearch = true;
					console.log('CAN SEARCH: ', vm.CanSearch);
				}, 500, vm);

        		return bizCoreService.Search(vm.SearchText, vm.MaxHits, vm.ReferrerType, vm.ReferrerId, [], vm.SearchIndexList).then(SearchCallback);

            	function SearchCallback(response) {
            		var results = BizPartCoreHelpers.getResponseValue(response, {});

            		for (var i = 0; i < results.IndexList.length; i++) {
            		    results.IndexList[i].Items = results.ResultItems.GetItemsByValue('Index', results.IndexList[i].Index);
            		    vm.SearchIndexList[i].TotalHits = results.IndexList[i].Items;
            		    vm.SearchIndexList[i].TotalHits = vm.HitsIncement;
            		}

            		vm.Results = results;
            		vm.Expand = true;
            	}
        	}

            function GoToResult(item) {
				vm.Expand = false;
            	bizCoreService.LogSearch(item);
            	window.location.href = bizSearchService.GetItemUrl(item);
			}

			function Init() {
			}
			
			this.$onInit = Init;
        }

        return directive;
    }

    function bizSearchService($state) {
    	this.CustomIndexUrls = {};

        this.GetItemUrl = function (item) {
            if (item.State == 'base.modules.educations') {
                // temphack for scorm
                return url = $state.href(item.State);
            }

    		var url = $state.href(item.State, JSON.parse(item.StateParameters));

    		if (!this.CustomIndexUrls[item.SearchIndexExternalName])
    			return url;

    		for (var i = 0; i < this.CustomIndexUrls[item.SearchIndexExternalName].length; i++) {
    			if (this.CustomIndexUrls[item.SearchIndexExternalName][i].ItemIds.indexOf(item.ItemId) > -1) {
    				return $state.href(this.CustomIndexUrls[item.SearchIndexExternalName][i].State, this.CustomIndexUrls[item.SearchIndexExternalName][i].StateParams)
						+ this.CustomIndexUrls[item.SearchIndexExternalName][i].Query.replace("#ITEMID#", item.ItemId);
    			}
    		}

    		return url;
    	}
    }
})(window.angular);
